import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { FormControl } from "@angular/forms";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/throttleTime";
import "rxjs/add/observable/fromEvent";
import { Subscription } from "rxjs";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { PatientListService } from "../services/patient-list.service";

@Component({
  selector: "app-schedmed-patient",
  templateUrl: "./schedmed-patient.component.html",
})
export class SchedmedPatientComponent implements OnInit {
  rowsData = [
    {
      title: "First Name",
      sorting: true,
      name: "patientFirstName",
      underline: true,
    },
    {
      title: "Last Name",
      sorting: true,
      name: "patientLastName",
      underline: true,
    },
    { title: "Address", tooltip: true },
    { title: "Mobile Number" },
    { title: "Alternate Number" },
    { title: "Email", sorting: true, name: "patientEmail" },
  ];
  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "patientCreatedOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;

  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private patientListService: PatientListService
  ) {}

  ngOnInit() {
    this.patientListService.init(this);
  }

  checkUrl() {
    this.patientListService.checkUrl(this);
  }

  getPatientList(event) {
    const data = this.patientListService.buildRequest(this, event, "sched");
    this.patientListService.loadPatients(this, data, (obj) => {
      const address = this.patientListService.buildAddress(obj);
      return {
        param1: obj.patientFirstName,
        param2: obj.patientLastName,
        param3: address ? address : "-",
        param4:
          obj.patientPhoneCode === "+91"
            ? this.patientListService.formatPhoneIn(
                obj.patientPhone,
                obj.patientPhoneCode
              )
            : this.patientListService.formatPhoneUs(
                obj.patientPhone,
                obj.patientPhoneCode
              ),
        param5:
          obj.altPatientPhone && obj.altPatientPhoneCode === "+91"
            ? this.patientListService.formatPhoneIn(
                obj.altPatientPhone,
                obj.altPatientPhoneCode
              )
            : obj.altPatientPhone && obj.altPatientPhoneCode === "+1"
            ? this.patientListService.formatPhoneUs(
                obj.altPatientPhone,
                obj.altPatientPhoneCode
              )
            : "",
        param6: obj.patientEmail,
        param12: obj.id,
        param11: obj.patientId,
        param13: "Double click for view",
      };
    });
  }

  pageChanged(event: any): void {
    this.patientListService.pageChanged(this, event);
  }

  onBlurMethod(val) {
    this.patientListService.onBlurMethod(this, val);
  }

  onBlurSearchMethod() {
    this.patientListService.onBlurSearchMethod(this);
  }
}
